<template>
  <b-row>
    <b-col
      align-self="end"
      class="mb-1"
    >
      <b-button
        class="ml-1 mr-1"
        variant="info"
        @click="setTimeA()"
      >
        شروع
      </b-button>
      <b-button
        variant="info"
        @click="setTimeB()"
      >
        پایان
      </b-button>

    </b-col>
    <b-col
      md="2"
      align-self="end"
    >
      <b-form-group
        label="bipbip"
        label-for="bipbip"
      >
        <b-form-input
          id="bipbip"
          v-model="value"
          autocomplete="off"
          @change="changeFormTime()"
        />
      </b-form-group>
    </b-col>
    <b-col md="auto">
      <video
          style="border-radius: 0.357rem;"
        ref="video"
        controls
        height="200"
      >
        <source :src="video">
      </video>
      <audio
        v-show="false"
        ref="audio"
        controls
      >
        <source :src="require('@/assets/audio/Bip.wav')">
      </audio>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'BipBip',
  props: ['video', 'value'],
  data() {
    return {
      BipTimeA: null,
      BipTimeB: null,
      Time: null,
      BipBipInterval: null,
    }
  },
  watch: {
    BipTimeB() {
      if (this.BipTimeA !== null) {
        this.value = this.BipTimeB - this.BipTimeA
        this.$refs.video.pause()
        this.$refs.video.currentTime = 0
        this.$refs.video.play()
      }
    },
    value(val){
      this.$emit('input',val)
    }
  },
  created() {
  },
  mounted() {
    const BipBip = () => {
      this.$refs.audio.play()
    }
    this.$refs.video.onplay = () => {
      this.BipBipInterval = setInterval(BipBip, this.value)
    }
    this.$refs.video.onpause = () => {
      clearInterval(this.BipBipInterval)
    }
    this.$refs.video.onended = () => {
      clearInterval(this.BipBipInterval)
      this.$refs.video.play()
    }
  },
  methods: {
    changeFormTime() {
      this.$refs.video.pause()
      this.$refs.video.currentTime = 0
      this.$refs.video.play()
    },
    setTimeA() {
      this.BipTimeA = Date.now()
    },
    setTimeB() {
      this.BipTimeB = Date.now()
    },
  },
}
</script>

<style scoped>

</style>
